import reducer from './reducer';
import * as selectors from './selectors';

export default reducer;
export { reducer, selectors };
